export const MY_FILES_STARTED = 'MY_FILES_STARTED';
export const MY_FILES_SUCCESS = 'MY_FILES_SUCCESS';
export const MY_FILES_FAILURE = 'MY_FILES_FAILURE';